import React, { useState } from 'react';

const MAX_SIZE_MB = 2;

export default function TrainingTextEditor({ value, image, onChange, rows = 8 }) {
  const [imgError, setImgError] = useState('');

  const handleImageFile = (file) => {
    if (!file) return;
    if (file.size > MAX_SIZE_MB * 1024 * 1024) {
      setImgError(`La imagen supera el límite de ${MAX_SIZE_MB} MB.`);
      return;
    }
    setImgError('');
    const reader = new FileReader();
    reader.onload = (e) => onChange({ body: value || '', image: e.target.result });
    reader.readAsDataURL(file);
  };

  return (
    <div className="form-group">
      <label className="form-label">Contenido</label>
      <textarea
        className="form-control"
        rows={rows}
        value={value || ''}
        onChange={(e) => onChange({ body: e.target.value, image: image || '' })}
        placeholder="Escribe el contenido de texto..."
      />
      <small className="text-muted mt-1 d-block">
        Usa <code>**palabra**</code> para resaltar palabras en negrita.
      </small>
      <div className="form-group mt-3">
        <label className="form-label">Imagen (opcional)</label>
        <input
          type="file"
          className="form-control"
          accept="image/*"
          onChange={(e) => handleImageFile(e.target.files[0])}
        />
        {imgError && <div className="text-danger small mt-1">{imgError}</div>}
        {image && (
          <div className="mt-2 d-flex align-items-center gap-2">
            <img
              src={image}
              alt="preview"
              style={{ maxHeight: 80, maxWidth: 120, objectFit: 'contain', borderRadius: 4, border: '1px solid #e2e8f0' }}
            />
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              onClick={() => onChange({ body: value || '', image: '' })}
            >
              <i className="fas fa-times" /> Quitar
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
